//#region Imports and Global Definitions
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet, View, SafeAreaView, Platform, useWindowDimensions, FlatList, } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../../styles/commonStyles';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../../components/CustomInput';
import CustomButton from '../../../../components/CustomButton';
import { ActivityIndicator, Card } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import { useCompany } from '../../../../hooks/useCompany';
import { useTableHelper } from '../../../../hooks/useTableHelper';
var _ = require('lodash');
import { useTranslation } from 'react-i18next';
//#endregion

const FlatListView = React.memo(({ item, index, props, styles, handleEditPress, duplicates,
    handleDelete, t }) => {
    const [showAdditionalInformation, setShowAdditionalInformation] = useState(false);

    let errorMark = false;
    let errorAttr = '';

    duplicates.forEach(duplicate => {
        if (duplicate.attrVal.includes(item[duplicate.attribute])) {
            errorMark = true;
            errorAttr = duplicate.attribute;
        }
    });
    useEffect(() => {
        //TODO
    }, [showAdditionalInformation])

    const onShowAdditionalLocationInfoPress = (item) => {
        setShowAdditionalInformation(!showAdditionalInformation)
    }

    return (
        <View>
            <SafeAreaView>
                <SafeAreaView>
                    <SafeAreaView
                        style={styles.row}>

                        {/* //* Always Visible */}
                        <SafeAreaView
                            style={styles.itemrow}>
                            <CustomLabel
                                value={t('common:salaryComponentDesc')}
                                type='SUBTITLENOFLEX' />

                            <CustomInput
                                // defaultValue={item?.desc}
                                value={item?.fieldcaption}
                                setValue={(e) => handleEditPress(index, item, 'fieldcaption', e)}
                                maxLen={255}
                                type={errorMark && errorAttr == 'fieldcaption' ? "MISSING_LOCATIONS_CODE" : "MAININPUT"}
                            />
                        </SafeAreaView>
                        <SafeAreaView>
                            <CustomButton
                                iconName={!showAdditionalInformation ? 'chevron-forward-outline' : 'chevron-down-outline'}
                                onPress={() => {
                                    onShowAdditionalLocationInfoPress(item, index)
                                }}
                                text={t('common:additionalInfos')}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                        </SafeAreaView>
                        <SafeAreaView style={styles.justMargin}>
                            <CustomButton
                                iconName='trash-outline'
                                onPress={() => {
                                    handleDelete(item, index, 'salarycomponentid')
                                }}
                                show='PART'
                                type='PART'
                                textTop='2'
                                sz={30} />
                        </SafeAreaView>
                    </SafeAreaView>

                    {showAdditionalInformation &&
                        <SafeAreaView style={styles.row}>

                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={t('common:formula')}
                                    type='SUBTITLE' />


                                <CustomInput
                                    defaultValue={item.formula}
                                    setValue={(e) => handleEditPress(index, item, 'formula', e)}
                                    type="MAININPUT"
                                />
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={t('common:order')}
                                    type='SUBTITLE' />
                                <CustomInput
                                    defaultValue={item.order}
                                    setValue={(e) => handleEditPress(index, item, 'order', e)}
                                    maxLen={50}
                                    type="MAININPUT"
                                />
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={t('common:evaluation')}
                                    type='SUBTITLE' />


                                <CustomInput
                                    defaultValue={item.evaluation}
                                    setValue={(e) => handleEditPress(index, item, 'evaluation', e)}
                                    maxLen={50}
                                    type="MAININPUT"
                                />
                            </SafeAreaView>

                        </SafeAreaView>
                    }
                </SafeAreaView>
            </SafeAreaView>
        </View >
    )
})

const HRAdminSalaryComponentsScreen = ({ props }) => {

    //#region Const Definitions
    const { width, height } = useWindowDimensions();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors, width, height, isPlatformWeb);
    const [salaryComponentsData, setSalaryComponentsData] = useState([]);
    const [refreshAfterSave, setRefreshAfterSave] = useState(false);
    const [originalData, setOriginalData] = useState([]);
    const [deletedItems, setDeletedItems] = useState([])
    const [duplicates, setDuplicates] = useState([])
    const { hasDuplicates, handleCancelChanges, rowAdd, rowDelete, rowEdit } = useTableHelper();
    const { getSalaryComponents, saveSalaryComponents, deleteSalaryComponent, isLoading } = useCompany();
    const ref = useRef(null);
    const companyRef = useRef(null);
    //#endregion

    // * Language
    const { t, i18n } = useTranslation();

    //#region UseEffect
    useEffect(() => {
        if ((companyRef.current !== null) && companyRef.current !== props.selectedCompany) {
            props.handleGoBack();
            return;
        }

        getSalaryComponents(props.salarySchemeId)
            .then((resp) => {
                setSalaryComponentsData(resp);
                setOriginalData(resp)
                props.setChanges({});

                setRefreshAfterSave(false);
            }).catch(() => {
                setRefreshAfterSave(false);
            })
    }, [props.salarySchemeId, props.selectedBranch, refreshAfterSave])

    //#endregion

    //#region Listeners
    const handleEditPress = useCallback((idx, item, key, value) => {
        rowEdit(idx, item, key, value, props.changes, props.setChanges, salaryComponentsData, setSalaryComponentsData)
    }, []);

    const removeFromChangesAfterSave = () => {
        props.setChanges([])
        setDeletedItems([])
    }

    // * Validator 
    // TODO Can be abstracted as well probably -- But column names matter ? 
    const validateInput = () => {
        let primarytDate = new Set();
        let ret = [true, t('common:validationSuccess')]
        salaryComponentsData.forEach((itr) => {
            // * Check empty description
            if (itr.fieldcaption === '')
                ret = [false, t('common:descEmpty')]
        })

        // console.log(ret)
        return (ret)
    }

    //#region SaveDeleteCancel
    const handleSave = async () => {
        let newPromises = [];
        let deleteSucc = false;
        let updateSucc = false;
        let valid = true;

        // * Do not save if Changes table is empty
        if (Object.entries(props.changes).length == 0 && deletedItems.length == 0) {
            showMessage({
                message: t('common:noChanges'),
                type: "danger",
                duration: 3000,
            })
            return
        }

        // * Check that there is only 1 entry without tdate which indicates the most recent Salary Scheme 
        // * Also check that the date is later than all the other from dates. 
        // ! We do not currently need to check if tdate < fdate because the calendar does not allow you to mkae that selection :)
        let valRet = validateInput();
        if (!valRet[0]) {
            showMessage({
                message: valRet[1],
                type: "danger",
                duration: 3000,
            })
        }

        //* Attribute definition of values that can be the same in salary schemes 
        const attributesToIgnore = ["salaryschemeid", "formula", "evaluation"];
        // * Check for duplicates,
        // * The loop from the one row is to avoid typing all the object attributes. 

        if (salaryComponentsData.length > 0)
            Object.keys(salaryComponentsData[0]).forEach(key => {
                //* Ignore Keys that we know can be duplicated 
                if (!attributesToIgnore.includes(key)) {
                    if (hasDuplicates(salaryComponentsData, key, setDuplicates)) {
                        showMessage({
                            message: t('common:duplicates'),
                            type: "danger",
                            duration: 3000,
                        })
                        // * Abort Save if this is triggered.
                        valid = false;
                    }
                }
            });

        if (!valid)
            return null;

        // TODO Check for dates descending  - TBH I do not see the reason of doing this currently. 
        // console.log(checkDatesDescending())

        //#region Create Promise
        if (Object.entries(props.changes).length > 0) {
            newPromises.push(
                saveSalaryComponents(props.changes)
                    .then((res) => {
                        if (res) {
                            updateSucc = res;
                            removeFromChangesAfterSave();
                        }

                    })
                    .catch(() => { }))
        }

        if (deletedItems.length > 0) {
            newPromises.push(deleteSalaryComponent(deletedItems)
                .then((res) => {
                    if (res) {
                        deleteSucc = true
                        removeFromChangesAfterSave();
                    }
                }).catch(() => { }))
        }

        //#endregion

        // * Send the Changes table in the API which only includes Updated or new Lines
        // * No check in the API if row changed. 
        try {
            await Promise.all(newPromises).then(() => {
                if (!updateSucc) {
                    if (!deleteSucc) {
                        showMessage({
                            message: t('common:deleteFailed'),
                            type: "danger",
                            duration: 3000,
                        })
                    }
                    else
                        showMessage({
                            message: t('common:issueMessage'),
                            type: "error",
                            duration: 3000,
                        })

                }
                else if (deleteSucc || updateSucc) {
                    showMessage({
                        message: t('common:allOperationsSuccMess'),
                        type: "success",
                        duration: 3000,
                    })
                    setRefreshAfterSave(true);
                }
            });
        } catch (error) {
            console.log(error)
            setRefreshAfterSave(true);
        }
    }
    const handleDelete = (item, index, attribute) => {
        rowDelete(item, index, attribute, props.changes, props.setChanges, salaryComponentsData, setSalaryComponentsData, setDeletedItems, ref)
    }

    //#endregion

    //#endregion

    //#region Components
    const renderData = useCallback((item, index) => {
        return (
            <Card
                style={[common.cardstyle]} >
                <Card.Content>
                    <FlatListView
                        item={item} index={index}
                        props={props}
                        styles={styles}
                        handleEditPress={handleEditPress}
                        duplicates={duplicates}
                        handleDelete={handleDelete}
                        t={t} />
                </Card.Content>
            </Card >
        )
    }, [salaryComponentsData, duplicates]);

    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <SafeAreaView style={styles.mainView}>
            <SafeAreaView style={styles.rowView}>
                <SafeAreaView style={[styles.subMain]}>
                    <View style={styles.innerView}>
                        <View style={[styles.buttons, styles.functionalityButtons]}>
                            {props.selectedBranch !== "" &&
                                (
                                    <>
                                        <CustomButton
                                            text={t('common:new')}
                                            onPress={() => { rowAdd(salaryComponentsData, setSalaryComponentsData, ['company', 'salaryschemeid'], [], ref, t, ['salaryschemeid'], [], props.changes, props.setChanges) }}
                                            type='BUTTON_ADD'
                                            textTop='0'
                                            sz={15}
                                        />
                                        {(Object.keys(props.changes).length > 0 || deletedItems.length > 0) &&
                                            <CustomButton
                                                text={t('common:saveChanges')}
                                                onPress={() => handleSave()}
                                                type='BUTTON_SAVE'
                                                textTop='0'
                                                sz={15}
                                                isGradient={true}
                                            />
                                        }
                                        <CustomButton
                                            text={t('common:cancel')}
                                            onPress={() => { handleCancelChanges(setSalaryComponentsData, originalData, setDeletedItems, props.setChanges, setDuplicates) }}
                                            type="BUTTON_CANCEL"
                                            sz={15}
                                        />
                                    </>
                                )}
                        </View>
                        <FlatList
                            style={styles.mainView}
                            data={salaryComponentsData}
                            keyExtractor={(item, index) => `${item.location}-${index}`}
                            renderItem={({ item, index }) =>
                                renderData(item, index)
                            }
                            scrollEnabled={true}
                            refreshing={isLoading}
                            ref={ref}
                            initialNumToRender={4}
                            ListEmptyComponent={
                                isLoading ?
                                    <ActivityIndicator animating={true} color={colors.blue} />
                                    :
                                    <CustomLabel
                                        value={t("common:locationsLoadingPreview")}
                                        type="NO_BRANCHES"
                                    />
                            }
                        />
                    </View>
                </SafeAreaView>
            </SafeAreaView >
        </SafeAreaView >
    )
};

//#region Styles
const makeStyles = (colors, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        marginHorizontal: 10,
    },
    subMain: {
        borderRadius: 35,
        elevation: (Platform.OS === 'web' && width > 992 ? 3 : 0),
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        width: '100%'
    },
    rowView: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    justMargin: {
        marginHorizontal: 10,
    },
    row: {
        flex: 1,
        margin: 10,
        flexDirection: "row",
        alignItems: 'center',
    },
    item: {
        flex: 1,
    },
    itemrow: {
        flex: 1,
        flexDirection: 'row',
    },
    buttonSelected: {
        margin: 10,
        borderRadius: 5,
        borderWidth: 2,
        elevation: 5,
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.3,
        shadowRadius: 5,
        backgroundColor: colors.background_card,
        borderColor: colors.buttons_submit,
    },
    functionalityButtons: {
        justifyContent: 'flex-end',
    },
    innerView: {
        flex: 1,
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '50%',
        alignSelf: 'flex-end',
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '4%'
    },
});


//#endregion
export default HRAdminSalaryComponentsScreen;